export const Navigation = (props) => {
  return (
  <nav
  id="menu"
  className="navbar navbar-expand-lg fixed-top shadow-sm"
  style={{
    background: "linear-gradient(90deg, #ff7b00, #ff9b2f)", // gradient orange
  }}
>
  <div className="container-fluid px-4">
    {/* Logo */}
    <a className="navbar-brand d-flex align-items-center" href="#home">
      <img
        src="img/hanumanlogo.jpg"
        alt="Logo"
        style={{
          height: "55px",
          width: "55px",
          borderRadius: "50%",
          border: "2px solid white",
          objectFit: "cover",
          marginRight: "10px",
        }}
      />
      <span className="fw-bold text-white fs-5">Hanuman action art
</span>
    </a>

    {/* Toggler */}
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* Links */}
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        {["About", "Services", "Portfolio", "Review", "Team", "Contact"].map(
          (item) => (
            <li className="nav-item" key={item}>
              <a
                className="nav-link text-white px-3 fw-semibold"
                href={`#${item.toLowerCase()}`}
              >
                {item}
              </a>
            </li>
          )
        )}
      </ul>
    </div>
  </div>
</nav>
  );
};
